import { asyncRouterMap, constantRouterMap } from 'src/router';
import { getPermission } from 'api/login';
import Cookies from 'js-cookie';
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route,list) {

    if(route.path.indexOf("/detail")>=0 || route.path == '/address'){
        return true;
    }else {
        if (route.path) {
            return list.indexOf(route.path) >= 0
        } else {
            return true
        }
    }
}
function orderRouter(accessedRouters,list) {
    let route = accessedRouters.find(item=>{return item.path == '/'});
    accessedRouters.forEach((route)=>{
        if("/" == route.path){

            let dateMap = new Map();
            let count = new Map();
            route.children.forEach((e,i)=>{
                dateMap.set(e.path,e)
            });

            let newChildren = [];
            list.forEach((e,i)=>{
                if(dateMap.get(e) != undefined && count.get(e) == undefined){
                    count.set(e,1);
                    newChildren.push(dateMap.get(e))
                }
            })
            route.children  = newChildren;
        }
    });
}
/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles,list) {
    const accessedRouters = asyncRouterMap.filter(route => {
        if (hasPermission(roles, route,list)) {
            if (route.children && route.children.length) {
                route.children = filterAsyncRouter(route.children, roles,list)
            }
            return true
        }
        return false
    });
    return accessedRouters
}


function getNowRouter(asyncRouterMap, to) {
    return asyncRouterMap.some(route => {
        if(to.path.indexOf(route.path) !==-1) {
            return true;
        }
        else if (route.children && route.children.length) { //如果有孩子就遍历孩子
            return  getNowRouter(route.children, to)
        }
    })

}



const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
        siderbar_routers:[],
        token: Cookies.get('Admin-Token')
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers;
            state.routers = constantRouterMap.concat(routers);
        },
        SET_NOW_ROUTERS: (state, to) => {
            // 递归访问 accessedRouters，找到包含to 的那个路由对象，设置给siderbar_routers
            state.addRouters.forEach(e => {
                if(e.children&& e.children.length ){
                    if( getNowRouter(e.children,to)===true) {
                        state.siderbar_routers = e;
                    }
                }
            })
        }
    },
    actions: {
        GenerateRoutes({ commit,state }, data) {
            return new Promise(resolve => {
                getPermission(state.token).then(response => {
                    const list = response.data;
                    const {roles} = data
                    let accessedRouters
                    if (roles.indexOf('admin') >= 0) {

                        accessedRouters = asyncRouterMap
                    } else {
                        accessedRouters = filterAsyncRouter(asyncRouterMap, roles,list)
                    }
                    orderRouter(accessedRouters,list)
                    commit('SET_ROUTERS', accessedRouters);
                    resolve();
                }).catch(error => {
                    alert(error)
                });
            })
        },

        getNowRoutes({ commit }, data) {
            return new Promise(resolve => {
                commit('SET_NOW_ROUTERS', data);
                resolve();
            })
        },
    },
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js